import { useEffect, useState } from "react";
import { catalogApi } from "@/lib/api/catalog";
import type { PublicationStatus } from "@/lib/catalog/catalog-workflow";
import { stateFromDraft, type JournalCatalogState } from "./journal-catalog-form";
import { catalogErrorMessage } from "./journal-catalog-error";

interface ToastErrors {
  error: (message: string) => void;
}

export function useJournalDraftLoader(id: string | undefined, toast: ToastErrors) {
  const [loadedState, setLoadedState] = useState<JournalCatalogState>();
  const [publicationStatus, setPublicationStatus] = useState<PublicationStatus>();
  const [loading, setLoading] = useState(Boolean(id));
  useEffect(() => {
    if (!id) return;
    let active = true;
    catalogApi
      .getJournalDraft(id)
      .then((draft) => {
        if (!active) return;
        setLoadedState(stateFromDraft(draft.payload));
        setPublicationStatus(draft.publicationStatus);
      })
      .catch((error: unknown) => {
        if (active) toast.error(catalogErrorMessage(error, "Failed to load journal draft."));
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, [id, toast]);
  return { loadedState, publicationStatus, loading };
}
